import React from "react";

export function Disclaimer() {
  return (
    <div className="legal-page">
      <article className="legal-content">
        <h1>Disclaimer</h1>
        <p className="legal-updated">Last updated: March 6, 2026</p>
        <p>
          NumisTrail provides digital tools to support transparency and
          provenance for collectibles.
        </p>
        <p>NumisTrail does not take custody of physical items.</p>
        <p>
          Digital Records, including NFTs (digital items), represent digital information only and do not
          constitute ownership of physical collectibles.
        </p>
        <p>
          NumisTrail is not a grading authority, auction house, insurer, escrow
          provider, broker, or investment advisor.
        </p>
        <p>
          Verification data may rely on third-party certification authorities
          and user-submitted information. NumisTrail does not guarantee the
          accuracy of third-party data.
        </p>
        <p>
          Items marked as USER_GENERATED are submitted by users and are not
          digitally certified by a trusted partner at the time of creation.
          Such items should be treated as not trusted-certified unless and until
          a promotion event is recorded.
        </p>
        <p>
          NumisTrail may modify, delete, or reassign USER_GENERATED records
          within the platform when required for operational integrity, legal
          compliance, fraud prevention, security, or dispute handling. These
          actions affect digital records only and do not determine physical
          custody, legal title, or possession of collectibles.
        </p>
        <p>
          A TRUSTED_CERTIFIED status indicates that an authorized trusted partner
          digitally certified the item within NumisTrail. It does not constitute
          a warranty of physical authenticity, legal ownership, valuation, market
          value, or fitness for investment.
        </p>
        <p>
          Certain data may be recorded on public blockchains and may be
          immutable and outside NumisTrail&apos;s control.
        </p>
        <p>
          The Service depends on third-party infrastructure and may be affected
          by external outages or failures.
        </p>
        <p>
          Users remain solely responsible for physical collectibles and related
          transactions.
        </p>
        <p className="legal-brand-notice">
          2026 NumisTrail (TM). A brand operated by Storychain Labs LLC.
        </p>
      </article>
    </div>
  );
}
